import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  HostListener,
  effect,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  imports: [CommonModule],
  templateUrl: './modal.html',
  styleUrl: './modal.css',
})
export class Modal {
  @Input({ required: true }) isOpen!: Signal<boolean>;
  @Input() title = '';
  @Input() maxWidth = '600px';
  @Input() showHeader = true;
  @Input() bodyPadding = '1.5rem';
  @Output() closed = new EventEmitter<void>();

  private previousActiveElement: HTMLElement | null = null;
  private focusableElements: HTMLElement[] = [];

  constructor(private elementRef: ElementRef) {
    effect(() => {
      if (this.isOpen()) {
        this.onOpen();
      } else {
        this.onClose();
      }
    });
  }

  @HostListener('document:keydown.escape')
  onEscapePress(): void {
    if (this.isOpen()) {
      this.close();
    }
  }

  onBackdropClick(event: MouseEvent): void {
  }

  close(): void {
    this.closed.emit();
  }

  private onOpen(): void {
    this.previousActiveElement = document.activeElement as HTMLElement;
    document.body.style.overflow = 'hidden';
    this.setupFocusTrap();
  }

  private onClose(): void {
    document.body.style.overflow = '';
    this.previousActiveElement?.focus();
  }

  private setupFocusTrap(): void {
    setTimeout(() => {
      const focusable = this.elementRef.nativeElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      this.focusableElements = Array.from(focusable);
      if (this.focusableElements.length > 0) {
        this.focusableElements[0].focus();
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (!this.isOpen() || event.key !== 'Tab' || this.focusableElements.length === 0) return;

    const firstFocusable = this.focusableElements[0];
    const lastFocusable = this.focusableElements[this.focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }
}
